export default __webpack_public_path__ + "static/bunty-087e445759aa6f92d4171b71d7408686.png";